// extracted by mini-css-extract-plugin
export default {"root":"K5Oh0lsE","specific":"_6FzSRPL7","homepagebutton":"ONAgPCLg"};